import { motion } from "framer-motion";

const ABOUT_IMG = "https://images.unsplash.com/photo-1526792678699-fcb4e5be0fd0?w=1000&q=80";

const pillars = [
  {
    num: "30+",
    label: "Años de experiencia",
    desc: "Equipo formado por expertos con décadas en la industria publicitaria.",
    color: "#00E0FF",
  },
  {
    num: "#1",
    label: "Red residencial",
    desc: "La red publicitaria residencial más grande de Chile.",
    color: "#D4AF37",
  },
  {
    num: "360°",
    label: "Gestión completa",
    desc: "Instalación, operación, medición y administración de cada campaña.",
    color: "#00E0FF",
  },
];

const SobreEdimedia = () => (
  <section
    id="sobre"
    data-testid="sobre-section"
    style={{
      backgroundColor: "#0F0F10",
      paddingTop: "120px",
      paddingBottom: "120px",
      borderTop: "1px solid rgba(255,255,255,0.05)",
    }}
  >
    <div className="edi-container">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 xl:gap-20">
        {/* Left: Text */}
        <div className="lg:col-span-6 xl:col-span-5 flex flex-col justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            <span className="section-label">Nuestra Historia</span>
            <div style={{ marginTop: "20px" }}>
              <div className="line-accent" />
            </div>
            <h2
              className="section-heading mb-6"
              style={{ fontSize: "clamp(42px, 5vw, 72px)" }}
            >
              Sobre{" "}
              <span style={{ color: "#00E0FF" }}>EDIMEDIA</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <p
              className="font-body text-zinc-400 mb-5"
              style={{ fontSize: "15px", lineHeight: 1.85, fontWeight: 300 }}
            >
              EDIMEDIA es una empresa formada por expertos con{" "}
              <strong className="text-white">más de 30 años de experiencia</strong> en la industria
              publicitaria, combinados con líderes del ecosistema inmobiliario chileno.
            </p>
            <p
              className="font-body text-zinc-400 mb-10"
              style={{ fontSize: "15px", lineHeight: 1.85, fontWeight: 300 }}
            >
              Nos especializamos en publicidad dentro de edificios residenciales y espacios urbanos,
              creando <strong className="text-white">conexiones poderosas</strong> entre marcas y los
              lugares donde las personas realmente viven.
            </p>
          </motion.div>

          {/* Pillars */}
          <div className="flex flex-col gap-0">
            {pillars.map((pillar, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="flex items-start gap-6"
                style={{
                  borderBottom: "1px solid rgba(255,255,255,0.06)",
                  padding: "24px 0",
                }}
              >
                <span
                  className="font-heading font-bold"
                  style={{ fontSize: "32px", color: pillar.color, minWidth: "72px", lineHeight: 1 }}
                >
                  {pillar.num}
                </span>
                <div>
                  <span
                    className="font-body font-bold uppercase text-white"
                    style={{ fontSize: "12px", letterSpacing: "0.15em", display: "block", marginBottom: "4px" }}
                  >
                    {pillar.label}
                  </span>
                  <span
                    className="font-body text-zinc-500"
                    style={{ fontSize: "13px", lineHeight: 1.6, fontWeight: 300 }}
                  >
                    {pillar.desc}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Right: Image */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-6 xl:col-span-7 relative"
        >
          <div className="relative overflow-hidden" style={{ height: "600px" }}>
            <img
              src={ABOUT_IMG}
              alt="Sobre EDIMEDIA"
              className="w-full h-full object-cover"
              style={{ filter: "brightness(0.6) saturate(0.7)" }}
            />
            <div
              className="absolute inset-0"
              style={{
                background: "linear-gradient(to bottom, transparent 60%, #0F0F10 100%)",
              }}
            />

            {/* Overlay badge */}
            <div
              className="absolute top-8 right-8"
              style={{
                backgroundColor: "rgba(5,5,5,0.85)",
                backdropFilter: "blur(12px)",
                border: "1px solid rgba(255,255,255,0.08)",
                padding: "24px 32px",
                textAlign: "center",
              }}
            >
              <div
                className="font-heading font-bold"
                style={{ fontSize: "48px", color: "#00E0FF", lineHeight: 1 }}
              >
                +30
              </div>
              <div
                className="font-body font-bold uppercase text-zinc-400"
                style={{ fontSize: "10px", letterSpacing: "0.2em", marginTop: "4px" }}
              >
                Años de experiencia
              </div>
            </div>
          </div>

          {/* Quote */}
          <div
            style={{
              backgroundColor: "#18181B",
              border: "1px solid rgba(255,255,255,0.06)",
              padding: "28px 32px",
              marginTop: "3px",
            }}
          >
            <p
              className="font-body text-zinc-400 italic"
              style={{ fontSize: "14px", lineHeight: 1.7, fontWeight: 300 }}
            >
              "Conectamos marcas, comunidades residenciales y administradores de edificios a través de
              una red publicitaria innovadora ubicada directamente en entornos residenciales."
            </p>
            <span
              className="font-body font-bold uppercase mt-4 block"
              style={{ fontSize: "10px", color: "#00E0FF", letterSpacing: "0.2em" }}
            >
              — EDIMEDIA.CL
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export { SobreEdimedia };
